<template>
    <div class="content_box">
        <div class="order_nav">
            <div class="nav_item" :class="{active: searchData.state == item.id}" v-for="(item) in orderNav" :key="item.id" @click="searchData.state = item.id">
                <p class="label">{{`${item.name}(${workNum[item.id] || 0})`}}</p>
                <p class="line"></p>
            </div>
        </div>
        <div class="order_manage">
            <div class="content"  ref="order_content">
                <div class="order_table">
                    <div class="search_box" ref="search_box">
                        <el-form :inline="true" :model="searchData" class="form-inline search-form form-list">
                            <el-form-item>
                                <el-select v-model="searchData.work_state" clearable placeholder="工单状态">
                                    <el-option label="受理中" value="Running"></el-option>
                                    <el-option label="已完结" value="End"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-select v-model="searchData.product_id" clearable placeholder="产品分类">
                                    <el-option :label="item.product_name" :value="item.product_id" v-for="item in product" :key="item.product_id + '123'"></el-option>
                                </el-select>
                            </el-form-item>
                            <template v-if="expand">
                                <el-form-item>
                                    <el-select v-model="searchData.product_type" placeholder="产品型号" clearable filterable :no-data-text="'暂无数据'">
                                        <el-option :label="item" :value="item" v-for="item in productTypes" :key="item + '321'" ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-cascader
                                    v-model="searchData.cate_ids"
                                    v-if="$store.state.type == 'pc'"
                                    :options="cate"
                                    :key='cascaderId'
                                    clearable
                                    filterable
                                    placeholder="问题分类"
                                    :props="{ expandTrigger: 'click', children: 'next', label: 'cate_name', value: 'cate_id', checkStrictly: true}"></el-cascader>
                                    <div class="cascader_box" v-else>
                                        <van-field
                                        v-model="cascaderLabel"
                                        is-link
                                        readonly
                                        clearable
                                        placeholder="问题分类"
                                        @click="cascaderShow = true"
                                        />
                                        <van-popup v-model="cascaderShow" round position="bottom">
                                            <van-cascader
                                                v-model="cascaderValue"
                                                title="问题分类"
                                                :options="cate"
                                                :fieldNames="{text: 'cate_name', children: 'next', value: 'cate_id'}"
                                                @close="cascaderShow = false"
                                                @finish="cascaderFinish"
                                            />
                                        </van-popup>
                                    </div>
                                </el-form-item>
                                <el-form-item>
                                    <el-select v-model="searchData.problem_source" filterable clearable placeholder="问题责任方" :no-data-text="'暂无数据'">
                                        <el-option :label="item" :value="item" v-for="item in problemSource" :key="item + '456'"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-select v-model="searchData.work_source" clearable placeholder="工单来源" filterable :no-data-text="'暂无数据'">
                                        <el-option :label="item" :value="item" v-for="item in source" :key="item + '176435'"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-select v-model="searchData.create_user_id" filterable clearable placeholder="创建人">
                                        <el-option :label="item.user_name" :value="item.user_id" v-for="item in user" :key="item.user_id + 423432"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item> 
                                    <el-select v-model="searchData.handler_id" filterable clearable placeholder="受理人">
                                        <el-option :label="item.user_name" :value="item.user_id" v-for="item in user" :key="item.user_id+5354"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item> 
                                    <el-select v-model="searchData.sell_channel" clearable filterable allow-create placeholder="销售渠道">
                                        <el-option-group
                                            v-for="group in salesChannels"
                                            :key="group.label"
                                            :label="group.label">
                                            <el-option
                                                v-for="item in group.options"
                                                :key="item"
                                                :label="item"
                                                :value="item">
                                            </el-option>
                                        </el-option-group>
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-select v-model="searchData.exchanged_arr" multiple placeholder="售后方式">
                                        <el-option label="无需" value="无需"></el-option>
                                        <el-option label="退货" value="退货"></el-option>
                                        <el-option label="换货" value="换货"></el-option>
                                        <el-option label="补发配件" value="补发配件"></el-option>
                                        <el-option label="维修" value="维修"></el-option>
                                    </el-select>
                                </el-form-item>
                                
                            </template>
                            <!-- label 使用el-select， el-form-item不设置prop 下拉箭头会失效 -->
                            <el-form-item class="searchSelect form_item" prop="searchInput">
                                <div slot="label">
                                    <el-select v-model="searchSelect">
                                        <el-option label="工单号" value="work_num"></el-option>
                                        <el-option label="产品SN号" value="product_sn"></el-option>
                                        <el-option label="工单标题" value="work_title"></el-option>
                                        <el-option label="外部工单号" value="work_idout"></el-option>
                                        <el-option label="销售订单号" value="sell_num"></el-option>
                                        <el-option label="注册邮箱/手机号" value="email_phone"></el-option>
                                    </el-select>
                                </div>
                                <el-input v-model="searchInput" placeholder="请输入"></el-input>
                            </el-form-item>
                            <template v-if="expand">
                                <el-form-item label="创建时间" class="date_picker form_item">
                                    <DatePicker :date="createTime" :clearable="true" @dateSelect="dateSelect"></DatePicker>
                                </el-form-item> 
                            </template>
                            <el-form-item>
                                <div class="button search" @click="search">
                                    <span>查询</span>
                                </div>
                                <div class="button search white" @click="init">
                                    <span>重置</span>
                                </div>
                                <div class="expand_btn" @click="expand = !expand">
                                    <span>{{expand ? '收起' : '高级查询'}}</span>
                                    <i :class="expand ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                                </div>
                            </el-form-item>
                        </el-form>
                        <div class="btn_box">
                            <div class="btn_left_box">
                                <el-radio-group v-model="myOrderType" size="small" v-show="searchData.state == 'work_create'">
                                    <el-radio-button label="all">{{`全部(${(myOrderData.total || 0)})`}}</el-radio-button>
                                    <el-radio-button label="reply">{{`新回复工单(${myOrderData.total_replay || 0})`}}</el-radio-button>
                                    <el-radio-button label="delay">{{`15天未处理工单(${myOrderData.total_delay || 0})`}}</el-radio-button>
                                </el-radio-group>
                            </div>
                            <div class="btn_right_box">
                                <div class="button button2" @click="$router.push({name: 'create-order'})" v-if="roleCheck('101-102-101-103')">
                                    <i class="el-icon-plus"></i>
                                    <span>新建</span>
                                </div>
                                <div class="button import" @click="openDialog('import', '导入工单')" v-if="roleCheck('101-102-101-104') && $store.state.type == 'pc'">
                                    <span>导入</span>
                                </div>
                                <div class="button export" @click="orderExport" v-if="roleCheck('101-102-101-105') && $store.state.type == 'pc'">
                                    <span>导出</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <el-table
                        :data="listData" ref="workTable" :height="tableHeight" highlight-current-row :fit="true" @row-click="goDetal" :key="tableList.join(',')">
                        <el-table-column fixed label="工单号"  min-width="120">
                            <template slot-scope="scope">
                                <el-badge is-dot class="item" :hidden="searchData.state != 'work_create' || !scope.row.unread_flag">
                                    <span>{{scope.row.work_num || '--'}}</span>
                                </el-badge>
                            </template>
                        </el-table-column>
                        <el-table-column fixed label="外部工单号" show-overflow-tooltip min-width="120">
                            <template slot-scope="scope">
                                <span>{{scope.row.work_idout || '--'}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column fixed label="工单优先级" min-width="100">
                            <template slot-scope="scope">
                                <span :class="'priority' + scope.row.priority">{{priority[scope.row.priority - 1]}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column fixed label="工单标题" min-width="150" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <img src="../../../assets/images/reminder.png" v-if="scope.row.reminder" alt="" class="reminder">
                                <span>{{scope.row.work_title || '--'}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column fixed label="工单状态">
                            <template slot-scope="scope">
                                <span class="state" :class="scope.row.work_state" v-if="scope.row.work_state == 'Running'">受理中</span>
                                <span class="state" :class="scope.row.work_state" v-else>已完结</span>
                            </template>
                        </el-table-column>
                        <el-table-column :width="columnWidth(item)" show-overflow-tooltip v-for="item in tableList" :key="item + 253543">
                                <template slot="header" slot-scope="scope">
                                    <span :key="item + 42343">{{item}}</span>
                                </template>
                                <template slot-scope="scope" >
                                    <span v-if="item == '工单来源'" :key="item + 423343">{{scope.row.work_source || '--'}}</span>
                                    <span v-if="item == '产品分类'" :key="item + 4233343">{{scope.row.product_name || '--'}}</span>
                                    <span v-if="item == '产品型号'" :key="item + 4233343">{{scope.row.product_type || '--'}}</span>
                                    <span v-if="item == '问题分类'" :key="item + 423343">{{scope.row.cate_name ? scope.row.cate_name.split('/')[scope.row.cate_name.split('/').length - 1] : '--'}}</span>
                                    <span v-if="item == '问题责任方'" :key="item + 423343">{{scope.row.problem_source || '--'}}</span>
                                    <span v-if="item == '创建人'" :key="item + 423343">{{scope.row.create_user_name || '--'}}</span>
                                    <span v-if="item == '受理人'" :key="item + 423343">{{scope.row.handler_name || '--'}}</span>
                                    <span v-if="item == '更新人'" :key="item + 423343">{{scope.row.update_user || '--'}}</span>
                                    <span v-if="item == '销售渠道'" :key="item + 4233343">{{scope.row.sell_channel || '--'}}</span>
                                    <span v-if="item == '订单号'" :key="item + 42333343">{{scope.row.sell_num || '--'}}</span>
                                    <span v-if="item == '订单日期'" :key="item + 4233343">{{scope.row.sell_time ? formDate(scope.row.sell_time, 'YYYY-MM-DD') : '--'}}</span>
                                    <span v-if="item == '售后方式'" :key="item + 4233343">{{scope.row.exchanged ? scope.row.exchanged : '--'}}</span>
                                    <span v-if="item == '客户注册邮箱/手机号'" :key="item + 42322243">{{scope.row.email_phone || '--'}}</span>
                                    <span v-if="item == '国家/地区'" :key="item + 42334343">{{scope.row.region || '--'}}</span>
                                    <span v-if="item == '更新时间'" :key="item + 4234434323">{{scope.row.update_time > 0 ? formDate(scope.row.update_time) : '--'}}</span>
                                    <span v-if="item == '创建时间'" :key="item + 42325343">{{scope.row.create_time > 0 ? formDate(scope.row.create_time) : '--'}}</span>
                                    <span v-if="item == '工单完结时间'" :key="item + 4235241243">{{scope.row.end_time > 0 ? formDate(scope.row.end_time) : '--'}}</span>
                                </template>
                        </el-table-column>
                        <el-table-column width="40">
                            <template slot="header" slot-scope="scope">
                                <i class="el-icon-setting settings" @click="checkDialog"></i>
                            </template>
                        </el-table-column>
                    </el-table>
                    <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination>
                </div>
                <importFileComponents ref="importDialog" name="工单" :uploadUrl="uploadUrl" downloadUrl="downloadFile" title="导入工单" @uploadChange="uploadChange"></importFileComponents>
                <Gh-Dialog class="settings" size="big" ref="settings" title="自定义设置工单字段" @dialogBack="settingsBack">
                    <template v-slot:content>
                        <div class="tbody_box">
                            <el-checkbox-group v-model="checkData" @change="handleCheckedChange" id="tbody_box">
                                <div class="check_item" v-for="(item,i) in tableData" :key="item + 4324324324">
                                    <div class="td">
                                        <el-checkbox :label="item">{{item}}</el-checkbox>
                                        <div class="act_box" v-show="checkData.indexOf(item) != -1">
                                            <div class="button button2" @click="checkSort('down', item, i)" v-show="i != checkData.length - 1">
                                                <span>下移</span>
                                            </div>
                                            <div class="button button2" @click="checkSort('up', item, i)" v-show="i != 0">
                                                <span>上移</span>
                                            </div>
                                            <div class="button button2" @click="checkSort('top', item, i)" v-show="i != 0">
                                                <span>置顶</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-checkbox-group>
                        </div>
                        <div class="thead_box">
                            <div class="th">
                                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                            </div>
                            <!-- <div class="th">排序</div> -->
                        </div>
                    </template>
                </Gh-Dialog>
            </div>
        </div>
    </div>
</template>
<script>
import resize  from "../../../minxins/resize"
import importFileComponents from '../../../components/dialog/import-file'
export default({
    name: 'order-manage',
    mixins: [resize],
    data() {
        return {
            expand: false,
            orderNav: [
                {
                    id: 'work_sum',
                    name: '全部工单'
                },{
                    id: 'work_create',
                    name: '我提交的工单'
                },{
                    id: 'work_running',
                    name: '我受理中的工单'
                },{
                    id: 'work_reply',
                    name: '我回复过的工单'
                },{
                    id: 'work_end',
                    name: '我的已完结工单'
                }
            ],
            workNum: {},
            createTime: [],
            searchData: {
                work_title: '',
                product_sn: '',
                work_idout: '',
                work_state: '',
                problem_source: '',
                product_id: '',
                product_type: '',
                cate_ids: [],
                create_start_time: 0,
                create_end_time: 0,
                update_start_time: 0,
                reply_end_time: 0,
                state: this.$route.query.state || 'work_sum',
                page_size: 10,
                page: 1
            },
            searchSelect: 'work_num',
            myOrderType: 'all',
            myOrderData: {},
            searchInput: '',
            total: 0,
            cascaderShow: false,
            cascaderValue: '',
            cascaderLabel: '',
            listData: [],
            tableHeight: 0,
            priority: ['低', '一般', '紧急'],
            product: [],
            cate: [],
            source: [],
            productTypes: [],
            problemSource: [],
            salesChannels: [],
            cascaderId: 1,
            user: [],
            uploadUrl: process.env.BASE_API + 'work/importFile',
            drawer: {
                type: '',
                title: '',
                show: false,
            },
            tableData: ['工单来源', '产品分类', '产品型号', '问题分类', '问题责任方', '创建人', '受理人', '更新人', '销售渠道', '订单号', '订单日期', '客户注册邮箱/手机号', '国家/地区', '售后方式', '更新时间', '创建时间', '工单完结时间'],
            tableList: [],
            checkData: [],
            isIndeterminate: false,
            checkAll: false
        }
    },
    components: {
        importFileComponents
    },
    watch: {
        'searchData.product_id': function(nId, oId){
            ++this.cascaderId;
            this.searchData.cate_ids = [];
            this.searchData.product_type = '';
            this.searchData.problem_source = '';
            this.productTypes = [];
            this.cate = [];
            if(nId){
                this.getCate(nId);
                this.getSource(nId);
            }else{  //全部分类
                this.problemSource = [];
            }
        },
        'searchData.state': function(nS, oS) {
            if(this.$route.query.state == nS) return;
            this.search();
            this.$router.replace('?state=' + nS);
        },
        myOrderType: function() {
            this.search();
        },
        createTime: function(nTime) {
            if(nTime) {
                this.searchData.create_start_time = nTime[0];
                this.searchData.create_end_time = nTime[1];
            }else{
                this.searchData.create_start_time = 0
                this.searchData.create_end_time = 0;
            }
            
        },
        searchSelect: function(nV, oV) {
            if(oV) {
                this.searchData[oV] = '';
            }
        },
        '$store.state.userInfo.word_rule': function(nR) {
            if(nR == 'Default') {  //默认列表展示所有信息
                this.checkData = [...this.tableData];
                this.checkAll = true;
            }else{
                this.checkData = nR ? nR.split(',') : [];
                this.checkAll = this.checkData.length === this.tableData.length;
                this.isIndeterminate = this.checkData.length > 0 && this.checkData.length < this.tableData.length;
            }
            this.tableList = [...this.checkData];
        },
        checkData: function(nV, oV){
            let noCheckArr = [];
            this.tableData.forEach(item => {
                if(nV.indexOf(item) == -1) {
                    noCheckArr.push(item);
                }
            })
            this.tableData = nV[0] === '' ? [...noCheckArr] : [...nV, ...noCheckArr];
        },
        expand: function() {
            this.setTableHeight();
        }
    },
    created() {
        this.getUser();
        this.getList();
        this.getProductCate();
        this.getWorkSource();
        this.getSellChannel();
        if(this.$store.state.userInfo.word_rule) {
            const nR = this.$store.state.userInfo.word_rule;
            if(nR == 'Default') {  //默认列表展示所有信息
                this.checkData = [...this.tableData];
                this.checkAll = true;
            }else{
                this.checkData = nR.split(',')
                this.checkAll = this.checkData.length === this.tableData.length;
                this.isIndeterminate = this.checkData.length > 0 && this.checkData.length < this.tableData.length;
            }
            this.tableList = [...this.checkData];
        }
    },
    mounted() {
        this.setTableHeight();
    },
    activated() {
        if(this.$route.params.reload) {
            this.init();
            this.getList();
            // this.$router.go(0);
            return;
        }
    },
    deactivated() {
        this.drawer.show = false;
    },
    methods: {
        init() {
            this.searchData = {
                work_title: '',
                work_idout: '',
                work_state: '',
                problem_source: '',
                product_id: '',
                product_type: '',
                cate_ids: [],
                create_start_time: 0,
                create_end_time: 0,
                update_start_time: 0,
                reply_end_time: 0,
                state: this.$route.query.state || this.searchData.state,
                page_size: this.searchData.page_size,
                page: 1
            };
            this.cascaderShow = false;
            this.cascaderLabel = '';
            this.cascaderValue = '';
            this.createTime = '';
            this.searchInput = '';
        },
        dateSelect(date) {
            this.createTime = date ? [...date] : '';
        },
        getWorkNum() {
            this.api.getWorkNum({}).then(data => {
                this.workNum = data.data;
            })
        },
        getUser() {
            this.api.getUser({order_rule: 'work-order'}).then(data => {
                this.user = data.data.userList;
            })
        },
        getWorkSource() {
            this.api.getWorkSource({}).then(data => {
                this.source = data.data.work_sources;
            });
        },
        getProductCate() {
            this.api.getProductCate({}).then(data => {
                this.product = [...data.data.productCateInfos];
                if(this.searchData.product_id) {
                    ++this.cascaderId;
                    this.cate = [];
                    this.getCate(this.searchData.product_id);
                    this.getSource(this.searchData.product_id);
                }
            })
        },
        getCate(id) {  //需要过滤掉next为空的属性
            this.api.getCate({product_id: id}).then( data => {
                this.cate = this.filterCate(data.data.cateInfos);
            })
        },
        filterCate(cate) {
            for(let i=0; i<cate.length; i++) {
                if(cate[i].next && cate[i].next.length > 0) {
                    cate[i].next = this.filterCate(cate[i].next)
                }else{
                    delete cate[i].next;
                }
            }
            return cate;
        },
        getSource(id) {
            for(let i=0; i<this.product.length; i++) {
                if(this.product[i].product_id == id) {
                    this.problemSource = this.product[i].problemSource;
                    this.productTypes = this.product[i].productTypes;
                    break;
                }
            }
        },
        getSellChannel() {
            this.api.getSellChannel({}).then(data => {
                this.salesChannels = data.data.sellObj;
            })
        },
        cascaderFinish({selectedOptions}) {
            this.cascaderShow = false;
            this.cascaderLabel = selectedOptions.map((option) => option.cate_name).join('/');
            this.searchData.cate_ids = selectedOptions.map((option) => option.cate_id);
        },
        initEcharts() {
            this.setTableHeight();
        },
        setTableHeight() {
            this.$nextTick(() => {
                const search_box = this.$refs.search_box;
                const order_content = this.$refs.order_content;
                const height = order_content.offsetHeight - search_box.offsetHeight;
                if(window.innerWidth < 768) {
                    this.tableHeight = '';
                }else if(height > 640 || height < 200) {
                    this.tableHeight = '510px';
                }else{
                    this.tableHeight = order_content.offsetHeight - search_box.offsetHeight - 134 + 'px';
                }
            })
        },
        getList() {
            this.getWorkNum();
            let searchData = {...this.searchData};
            searchData.product_id = searchData.product_id ? searchData.product_id : 0;
            if(this.searchData.state == 'work_create') {
                let createWorkerData = {...this.searchData};
                createWorkerData.is_replay_new = true;
                createWorkerData.is_delay = true;
                this.api.getCreateWorkNum(searchData).then(data => {
                    this.myOrderData = data.data;
                })
                if(this.myOrderType == 'reply') {
                    searchData.is_replay_new = true;
                }else if(this.myOrderType == 'delay') {
                    searchData.is_delay = true;
                }
            }
            this.api.getWorkList(searchData).then(data => {
                this.listData = data.data.workList;
                this.total = data.data.total;
            })
        },
        search() {
            this.searchData.page = 1;
            this.searchData[this.searchSelect] = this.searchInput;
            this.getList();
        },
        columnWidth(item) {
            let w;
            switch(item) {
                case '创建人': 
                case '受理人':
                case '更新人':
                case '国家/地区':
                    w = 100; break;
                case '销售渠道':
                case '订单号':
                    w = 140; break;
                case '客户注册邮箱/手机号':
                case '更新时间':
                case '创建时间':
                case '工单完结时间':
                    w = 160; break;
                default: w = 120;
            }
            return w;
        },
        goDetal(row, column, event) {
            if(window.h5sdk) {
                this.$router.push({name: 'order-detail', params: {id: row.work_id}, query: {title: row.work_title}});
                return;
            }
            const detail = this.$router.resolve({
                name: `order-detail`,
                params: {
                    id: row.work_id
                },
                query: {
                    title: row.work_title
                }
            });
            window.open(detail.href, "_blank");
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getList();
        },
        openDialog(type, title) {
            this.$refs.importDialog.openDialog();
        },
        uploadChange() {
            this.searchData.state = 'work_sum';
            this.getWorkNum();
            this.getList();
            this.$router.replace('?state=work_sum');
        },
        orderExport() {
            this.api.orderExport(this.searchData).then(data => {})
        },
        checkDialog() {
            this.$refs.settings.show = true;
        },
        handleCheckAllChange(val) {
            this.checkData = val ? this.tableData : [];
            this.isIndeterminate = false;
        },
        handleCheckedChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.tableData.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.tableData.length;
        },
        checkSort(type, item, i) {
            if(type == 'up') { //上移
                if(i == 0) return;
                this.checkData[i] = this.checkData.splice(i-1, 1, this.checkData[i]).join();
            }else if(type == 'down') { //下移
                if(i == this.checkData.length - 1) return;
                this.checkData[i+1] = this.checkData.splice(i, 1, this.checkData[i+1]).join();
            }else{ //置顶
                if(i == 0) return;
                this.checkData = (this.checkData.splice(i, 1)).concat(this.checkData);
            }
        },
        settingsBack() {
            this.api.orderListRule({word_rule: this.checkData.join(',')}).then(data => {
                this.getUserInfo();
                this.tableList = this.checkData.length > 0 ? [...this.checkData] : [];
                this.$refs.settings.show = false;
            })
        }
    }
})
</script>
<style lang="less" scoped>
    .content_box{
        padding: 0;
        .order_nav{
            .flexLayout(flex-start);
            min-width: 180px;
            width: auto;
            font-size: 15px;
            font-weight: 600;
            line-height: 24px;
            border-right: 1px solid #333;
            background-color: @colorWhite;
            .nav_item{
                cursor: pointer;
                margin: 0 30px;
                .label{
                    margin: 20px 0 8px;
                }
                .line{
                    width: 78px;
                    border-width:3px;
                    border-color: #fff;
                    position: relative;
                    left: 50%;
                    transform: translate(-50%, 0);
                    margin: 0;
                }
                &.active{
                    color: #2A79FF;
                    .line{
                        border-color: #2A79FF;
                    }
                }
            }
        }
    }
    .order_manage{
        padding: @area-padding;
        height: calc(100% - 55px);
        box-sizing: border-box;
        /deep/ .order_table{
            user-select: none;
            .datepicker,.cascader_box{
                width: 200px;
            }
            .btn_box{
                .flexLayout(space-between);
                .button{
                    width: 90px;
                }
            }
            .expand_box{
                display: flex;
            }
            .expand_btn{
                display: inline-block;
                margin-right: 20px;
                font-size: 14px;
                line-height: 34px;
                color: #2A79FF;
                cursor: pointer;
            }
            .reminder{
                width: 20px;
                display: inline-block;
                position: relative;
                top: 5px;
            }
            
            td{
                cursor: pointer;
            }
            .priority1{
                color: @color333;
            }
            .priority2{
                color: #2A79FF;
            }
            .priority3{
                color: #EB534B;
            }
            .state{
                padding: 5px 9px;
                background-color: #E4F9F8;
                color: #00D6B9;
                border-radius: 4px;
            }
            .Running{
                background-color: #E1EAFF;
                color: #2A79FF;
            }
            .settings{
                font-size: 16px;
                cursor: pointer;
            }
            .el-badge__content.is-fixed.is-dot{
                width: 6px;
                height: 6px;
                right: 0;
                top: 5px;
            }
            @media (max-width: 768px) {
                .el-form-item__content{
                    line-height: 28px;
                }
                .datepicker{
                    width: 249px;
                    .date_box{
                        line-height: 26px;
                        margin-left: -3px;
                        background: #fff;
                        border-radius: 0 4px 4px 0;
                    }
                }
                
                .el-input__inner{
                    width: 200px;
                }
                .cascader_box{
                    width: 160px;
                    .van-cell {
                        margin: 3px 0;
                    }
                }
                
            }
        }
        /deep/.settings{
            .el-dialog__body{
                padding: 20px 0 0;
            }
            .el-dialog__footer{
                padding-top: 0
            }
            .thead_box{
                .flexLayout(space-between);
                padding: 10px 20px;
                border-top: 1px solid @colorLine;
            }
            .tbody_box{
                height: 400px;
                overflow: auto;
                .check_item{
                    padding: 0 20px;
                    margin-bottom: 15px;
                    .td{
                        .flexLayout(space-between);
                        .act_box{
                            color: #333;
                            .button{
                                width: 60px;
                                line-height: 22px;
                                font-size: 12px;
                                margin: 0 5px;
                                @media(max-width: 768px) {
                                    width: 40px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/order/order-manage/order-manage.vue